const angular = require('angular');
const ngRoute = require('angular-route');
import routing from './dailyReport.routes';

export default angular.module('nomasvelloDashboardApp.dailyReport', [
    ngRoute])
    .config(routing)
    .name;



// WEBPACK FOOTER //
// ./client/app/dailyReport/index.ts